module.exports = __webpack_public_path__ + "img/title+@2x.e793b9af.png";